import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { Drawer } from "vaul";
import { DrawerContent } from "./DrawerContent";
import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";

export default function DoorMobileDrawer({
  addToCart,
}: {
  addToCart: () => void;
}) {
  const { getDoorProduct } = useConfigurationOptionsContext();

  const product = getDoorProduct();

  return (
    <Drawer.Root modal={false}>
      <Drawer.Trigger asChild>
        <motion.button
          className="gg-flex gg-items-center gg-gap-x-1"
          whileTap={{ scale: 1.015, translateY: 0.5 }}
        >
          <p className="gg-text-[11.5px] gg-tracking-wide gg-text-secondary-text">
            Bekijk productdetails
          </p>
          <div className="gg-grid gg-h-5 gg-w-5 gg-place-items-center gg-rounded-full gg-bg-dark-blue">
            <FontAwesomeIcon
              icon={faChevronDown}
              size="sm"
              className="gg-cursor-pointer gg-text-white gg-transition gg-duration-500 gg-ease-in-out"
            />
          </div>
        </motion.button>
      </Drawer.Trigger>
      <Drawer.Portal>
        <div className="gg-fixed gg-inset-0 gg-z-10 gg-h-full gg-bg-black/40"></div>
        <Drawer.Content className="gg-fixed gg-bottom-0 gg-left-0 gg-right-0 gg-z-50 gg-flex gg-h-min gg-flex-col gg-rounded-t-[10px] gg-bg-gray-100">
          <div className="gg-flex-1 gg-rounded-t-[10px] gg-px-4 gg-py-4">
            <div className="gg-mx-auto gg-h-1.5 gg-w-12 gg-flex-shrink-0 gg-rounded-full gg-bg-gray-300" />
            <div className="gg-mx-auto gg-max-w-md">
              <Drawer.Title className="gg-mb-4 gg-mt-3.5 gg-flex gg-justify-between">
                <span className="gg-text-lg gg-font-bold">
                  {product.doorName}
                </span>
                <span className="gg-mb-0.5 gg-self-end gg-text-sm">
                  {product.doorPrice}
                </span>
              </Drawer.Title>
              <Drawer.Description className="gg-sr-only">
                GewoonGers
              </Drawer.Description>
              <DrawerContent product={product} />
            </div>
          </div>
          {/* Bottom part */}
          <div className="gg-mt-auto gg-flex gg-justify-end gg-border-t gg-border-gray-200">
            <button
              type="button"
              onClick={() => addToCart()}
              data-testid="add-to-cart-mobile"
              className="gg-justify-center gg-rounded-[4px] gg-bg-yellow-300 gg-px-4 gg-py-3 gg-text-xs gg-font-bold gg-text-dark-blue hover:gg-bg-yellow-400 hover:gg-text-zinc-900 sm:gg-px-8 md:gg-px-12"
            >
              In winkelmand
            </button>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
